import React, { useRef, useEffect, useState } from 'react'
import { gsap } from 'gsap'
import NumberField from '../../../components/CustomInput/NumberField';
import AlarmInfoIconAndTitle from '../AlarmInfoIcon'
import { FormattedMessage, IntlShape, useIntl } from 'react-intl';

interface Props {
    count: number | null
    clearCount: number | null
    handleAlarmChanges: (type: string, value: string | number) => void
}

const Page3: React.FC<Props> = ({count, clearCount, handleAlarmChanges }) => {

    const intl:IntlShape = useIntl()

    const setCountTitleRef = useRef<HTMLHeadingElement>(null)
    const setTriggerCountRef = useRef<HTMLDivElement>(null)
    const clearTriggerCountRef = useRef<HTMLDivElement>(null)

    const selectStyle = {
        width: '50%',
        margin: '20px',
        opacity: 0
    }



    useEffect(() => {
        const setCountTitle = setCountTitleRef?.current
        const setTriggerCount = setTriggerCountRef?.current
        const clearTriggerCount = clearTriggerCountRef?.current


        const entryGsap = {
            opacity: 1,
            duration: 0.4,
            ease: 'power2.out'
        }
        const gap = '-=0.3'

        const tl = gsap.timeline()

        tl.to(setCountTitle, entryGsap)
        tl.to(setTriggerCount, entryGsap, gap)
        tl.to(clearTriggerCount, entryGsap, gap)


    }, [])


    return (
        <div style={{ padding: 30 }}>
            <h4 ref={setCountTitleRef}><b><FormattedMessage id="Set Alarm Counts" /></b></h4>
            <div style={{ display: 'flex', width: '100%' }}>
                <div style={selectStyle} ref={setTriggerCountRef}>
                    <AlarmInfoIconAndTitle title={intl.formatMessage({ id: "Set Count" })} text={intl.formatMessage({ id: "The number of consecutive data points to meet threshold before the alarm is triggered" })} />
                    <NumberField
                        value={count}
                        onValueChange={(e: number): void => handleAlarmChanges('count', e)}
                        min={1}
                        fullWidth
                        width='100%'
                    />
                </div>
                <div style={selectStyle} ref={clearTriggerCountRef}>
                    <AlarmInfoIconAndTitle title={intl.formatMessage({ id: "Clear Count" })} text={intl.formatMessage({ id: "The number of consecutive data points to meet clear threshold before the alarm is cleared" })} />
                    <NumberField
                        value={clearCount}
                        onValueChange={(e: number): void => handleAlarmChanges('clearCount', e)}
                        min={1}
                        fullWidth
                        width='100%'
                    />
                </div>
            </div>
        </div>

    )
}
export default Page3